// src/chartConfig.js

/**
 * Chart configuration module for the application.
 * Defines the styling and behavior settings for various chart types.
 */

/**
 * Configuration options for the main line chart.
 * Includes settings for time-based x-axis, dual y-axes, and interactive features.
 * @type {Object}
 * @property {Object} scales - Axis configurations
 * @property {Object} plugins - Chart plugin configurations
 */
export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      type: "time",
      time: {
        unit: "day",
        displayFormats: {
          day: "MM/dd/yyyy",
        },
        tooltipFormat: "MM/dd/yyyy HH:mm",
      },
      title: {
        display: true,
        text: "", // Localized in component
      },
    },
    y: {
      type: "linear",
      beginAtZero: true,
      min: 0,
      display: true,
      position: "left",
      title: {
        display: true,
        text: "", // Localized in component
      },
      ticks: {
        font: {
          size: 10,
        },
      },
      grid: {
        drawOnChartArea: false,
      },
      sync: true,
    },
    y1: {
      type: "linear",
      beginAtZero: true,
      min: 0,
      display: false,
      position: "right",
      title: {
        display: true,
        text: "", // Localized in component
      },
      grid: {
        drawOnChartArea: false,
      },
    },
  },
  plugins: {
    legend: { position: "top" },
    title: {
      display: true,
      text: "", // Localized in component
    },
    zoom: {
      pan: {
        enabled: true,
        mode: "xy",
      },
      zoom: {
        wheel: { enabled: true },
        pinch: { enabled: true },
        mode: "xy",
        drag: { enabled: true },
      },
    },
  },
};

/**
 * Configuration options for the bar chart.
 * Includes settings for monthly consumption visualization.
 * @type {Object}
 * @property {Object} scales - Axis configurations
 * @property {Object} plugins - Chart plugin configurations
 */
export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    y: {
      beginAtZero: true,
      min: 0,
      title: {
        display: true,
        text: "", // Localized where used
      },
    },
    x: {
      title: {
        display: true,
        text: "", // Localized where used
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "", // Localized where used
    },
  },
};
